/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The StokvelActive model module.
 * @module model/StokvelActive
 * @version v1
 */
export class StokvelActive {
  /**
   * Constructs a new <code>StokvelActive</code>.
   * @alias module:model/StokvelActive
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>StokvelActive</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StokvelActive} obj Optional instance to populate.
   * @return {module:model/StokvelActive} The populated <code>StokvelActive</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new StokvelActive();
    }
    return obj;
  }
}
